// extracted by css-extract-rspack-plugin
export default {"container":"_aa84f98a"};